import { IVector3 } from '../types';

export function getDistanceBetweenVectors3D(vec1: IVector3, vec2: IVector3, ignoreZ = false): number {
	const dx = vec2.x - vec1.x;
	const dy = vec2.y - vec1.y;
	const dz = ignoreZ ? 0 : vec2.z - vec1.z;
	return Math.sqrt(dx * dx + dy * dy + dz * dz);
}
